module.exports = __webpack_public_path__ + "img/theCover_07.d8beac8d.jpg";